import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Nav } from "react-bootstrap";
import { TfiLayoutGrid2Alt } from "react-icons/tfi";
import { BiSolidGridAlt } from "react-icons/bi";
import { PiBankFill } from "react-icons/pi";
import { PiChatCenteredTextFill } from "react-icons/pi";
import { PiWalletFill } from "react-icons/pi";
import { PiHourglassLowFill } from "react-icons/pi";
import { IoMdDocument } from "react-icons/io";
import { PiUsersThreeFill } from "react-icons/pi";
import { PiFileTextFill } from "react-icons/pi";
import { useNavigate, useLocation } from "react-router-dom";
import { url, subscriptionKey } from "../../constants";
import { PermissionActions } from "../../actions";
import { connect } from "react-redux";
import { Spinner } from "react-bootstrap";
import { Api } from "../../services/httpService";
import "../../../src/TextFamily.css";
import "./DeshBoard.css";
import {
  FaBook,
  FaClipboardList,
  FaHome,
  FaUsers,
  FaReceipt,
}
from "react-icons/fa";
import { IoWallet } from "react-icons/io5";
import { RiBankFill } from "react-icons/ri";
import { RxLapTimer } from "react-icons/rx";
import CmsModal from "../../components/Modals/CmsModal/CmsModal";

function VirticalNavigation(props) {
  const iconMapping = {
    FaHome: FaHome,
    FaUsers: FaUsers,
    FaClipboardList: FaClipboardList,
    FaBook: FaBook,
    FaUsers: FaUsers,
    IoWallet: IoWallet,
    RiBankFill: RiBankFill,
    FaReceipt: FaReceipt,
    RxLapTimer: RxLapTimer,
    // Add more mappings as needed
  };
  let navigate = useNavigate();
  const location = useLocation();
  const [openModal, setOpenModel] = useState(false);
  const [sidebar, setSidebar] = useState(false);
  // let {id} = useParams();
  let id = null;

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHomePage, setIsHomePage] = useState(false);

  const [currentUrl, setCurrentUrl] = useState(location?.pathname);
  // useEffect(() => {
  //   if (window.localStorage.getItem("_id")) {
  //     id = window.localStorage.getItem("_id");
  //     let tokenHeader = "";
  //     if (localStorage.getItem("_token")) {
  //       tokenHeader = localStorage.getItem("_token");
  //     }
  //     const apiUrl = `${url}/merchant/${id}`;
  //     fetch(apiUrl, {
  //       headers: {
  //         "Ocp-Apim-Subscription-Key": subscriptionKey,
  //         Authorization: tokenHeader,
  //       },
  //     })
  //       .then((res) => res.json())
  //       .then((data) => {
  //         if (data.success != true) {
  //           navigate(`/`);
  //         }

  //         let buyerPlatforms = data.body?.buyerPlatforms;
  //         let isVarified = buyerPlatforms?.some((element) => {
  //           return element.status.toLowerCase() === "verified";
  //         });

  //         if (
  //           data?.body?.company?.profileStatus != "COMPLETED" ||
  //           data?.body?.bankStatus != "VERIFIED" ||
  //           data?.body?.documentStatus != "VERIFIED" ||
  //           isVarified != true
  //         ) {
  //           setIsHomePage(true);
  //         } else {
  //           setIsHomePage(false);
  //         }
  //       });
  //   } else {
  //     navigate(`/`);
  //   }
  // }, props);

  useEffect(() => {
    const id = window.localStorage.getItem("_id");

    if (id) {
      let tokenHeader = "";
      if (localStorage.getItem("_token")) {
        tokenHeader = localStorage.getItem("_token");
      }

      const apiUrl = `${url}/merchant/${id}`;

      fetch(apiUrl, {
        headers: {
          "Ocp-Apim-Subscription-Key": subscriptionKey,
          Authorization: tokenHeader,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success !== true) {
            navigate(`/`);
            return;
          }

          const buyerPlatforms = data.body?.buyerPlatforms || [];
          const isVerified = buyerPlatforms.some(
            (element) => element.status?.toLowerCase() === "verified"
          );

          if (
            data?.body?.company?.profileStatus !== "SUBMITTED" ||
            data?.body?.bankStatus !== "VERIFIED" ||
            data?.body?.documentStatus !== "VERIFIED" ||
            isVerified !== true
          ) {
            setIsHomePage(true);
          } else {
            setIsHomePage(false);
          }
        })
        .catch(() => {
          navigate(`/`);
        });
    } else {
      navigate(`/`);
    }
  }, [navigate, url, subscriptionKey]);

  const showModal = (index) => {
    setCurrentIndex(index);
    setOpenModel(true);
  };

  const closeModal = () => {
    setOpenModel(false);
  };

  const toggleSidebar = () => {
    if (sidebar) {
      setSidebar(false);
    } else {
      setSidebar(true);
    }
  };

  const gotoPage = (url) => {
    navigate(url);
  };

  // useEffect(() => {
  //   if (window.localStorage.getItem("_id")) {
  //     props.getMenuList("Merchant");
  //     const type = "menu_access";
  //     const roleId = window.localStorage.getItem("_roleId");
  //     if (!roleId) {
  //       const res = Api("post", "/users/logout");
  //       if (res) {
  //         window.localStorage.clear();
  //         window.location.reload();
  //       }
  //     }
  //     props.getUserAccessList(roleId, type);
  //     props.getPermissionAccess(roleId, type);
  //   } else {
  //     navigate(`/`);
  //   }
  // }, props);

  useEffect(() => {
    if (window.localStorage.getItem("_id")) {
      props.getMenuList("Merchant");
      const type = "menu_access";
      const roleId = window.localStorage.getItem("_roleId");

      if (!roleId) {
        const res = Api("post", "/users/logout");
        if (res) {
          window.localStorage.clear();
          window.location.reload();
        }
      }

      props.getUserAccessList(roleId, type);
      props.getPermissionAccess(roleId, type);
    } else {
      navigate(`/`);
    }
  }, [props.getMenuList, props.getUserAccessList, props.getPermissionAccess, navigate]);

  const checkUrlAccess = async (Url, menuList) => {
    // setTimeout(() => {
    // For other URLs, filter the menu list
    const filteredResult = menuList.filter((item) =>
      item.menuUrl.includes(Url)
    );
    if (filteredResult?.length < 1) {
      const baseUrl = currentUrl.split("/").slice(0, 3).join("/") + "/:id";
      let roleMenuData = menuList.find((item) => item.menuUrl === baseUrl);
      if (roleMenuData && !checkPermission(roleMenuData.title)) {
        // Redirect to unauthorized page
        navigate({
          pathname: "/user/UnAuthorized",
          state: {
            prePath: Url,
          },
        });
        return; // Exit the function
      }
    } else {
      // Check permission for the specific URL
      if (!props?.userAccess) {
        console.error("userAccess is null or undefined");
      } else {
        if (
          window.localStorage.getItem("_frstlog") === "true" &&
          props?.userAccess?.length > 0
        ) {
          if (filteredResult?.length > 0) {
            for (let i = 0; i < filteredResult?.length; i++) {
              if (checkPermission(filteredResult[i].title)) {
                localStorage.setItem("_frstlog", false);
                navigate({
                  pathname: filteredResult[i].menuUrl,
                  state: {
                    prePath: Url,
                  },
                });
                break;
              }
            }
          } else {
            if (
              !checkPermission(filteredResult[0].title) ||
              filteredResult[0].menuUrl != Url
            ) {
              // Redirect to unauthorized page
              navigate({
                pathname: "/user/UnAuthorized",
                state: {
                  prePath: Url,
                },
              });
              // return; // Exit the function
            }
          }
        } else {
          if (
            !checkPermission(filteredResult[0].title) ||
            filteredResult[0].menuUrl != Url
          ) {
            // Redirect to unauthorized page
            navigate({
              pathname: "/user/UnAuthorized",
              state: {
                prePath: Url,
              },
            });
            // return; // Exit the function
          }
        }
      }
    }
    // }, 2000);
  };

  const checkPermission = (value) => {
    if (!props?.userAccess) {
      console.error("userAccess is null or undefined");
      return false;
    }
    return props?.userAccess?.some((item) => item.allow_action === value);
  };

  useEffect(() => {
    if (
      !props.permissionLoading &&
      currentUrl !== "/user/UnAuthorized" &&
      props.menuList?.length > 0
    ) {
      const upCurrentUrl = currentUrl == "/user" ? "/" : currentUrl;
      checkUrlAccess(upCurrentUrl, props.menuList);
    }
  }, [currentUrl, props.menuList, props.permissionLoading]);

  const menuItems = useMemo(() => {
    if (!props.permissionLoading) {
      // if (!props.menuList?.length) return null; // Handle empty menuList
      return (
        props?.menuList?.length > 0 &&
        props?.menuList
          .map((item, index) => {
            const IconComponent = iconMapping[item.icon];
            if (item.icon && item.isDisplay && checkPermission(item.title) && localStorage.getItem("accountStatus") === "Active") {
              return (
                <Nav.Link
                  href={item.menuUrl}
                  key={index}
                  className={(item.menuUrl == currentUrl) ? "active" : (item.menuUrl == '/' && currentUrl == '/user') ? "active" : (currentUrl === '/user/createRequest' && item.menuUrl === '/' && navigate?.location?.state?.prePath === 'user') ? "active" : (currentUrl === '/user/createRequest' && item.menuUrl === '/user/requests' && navigate?.location?.state?.prePath != 'user') ? "active" : "active-remove"}
                >
                  <span>
                    {IconComponent && (
                      <IconComponent className="" size={20} />
                    )}
                  </span>
                  {item.title}
                </Nav.Link>
              );
            }
            else if (localStorage.getItem("accountStatus") !== "Active" && item.title === "Dashboard") {
              return (
                <Nav.Link
                  href={item.menuUrl}
                  key={index}
                  // Temporarily set all to inactive 
                  className="active"
                >
                  <span>
                    {IconComponent && (
                      <IconComponent className="" size={20} />
                    )}
                  </span>
                  {item.title}
                </Nav.Link>
              );
            }
            return null; // Ensure to return null for items that don't match the conditions
          })
          .filter(Boolean)
      ); // Filter out null values
    }
  }, [props.menuList, currentUrl, props.permissionLoading]);



  return (
    <div>
      <Nav defaultActiveKey="/home" className="flex-column">
        {menuItems}
      </Nav>
      <div className="nav-term-condition mt-auto" onClick={() => showModal()}>
        Terms & Conditions
      </div>

      <CmsModal
        openModal={openModal}
        closeModal={() => closeModal()}
        modalTitle="Terms & Conditions"
      />
    </div>
  );
}

const mapStateToProps = ({ PermissionReducers }) => {
  return {
    menuList: PermissionReducers.menuList,
    userAccess: PermissionReducers.userAccess,
    // permissionAccess:PermissionReducers.permissionAccess,
    permissionLoading: PermissionReducers.loading,
  };
};

const mapDispatchToProps = {
  getMenuList: PermissionActions.getMenuList,
  getUserAccessList: PermissionActions.getUserAccessList,
  getPermissionAccess: PermissionActions.getPermissionAccess,
};

export default connect(mapStateToProps, mapDispatchToProps)(VirticalNavigation);
